import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import st from './InputWithIcon.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'

const InputWithIcon = forwardRef(
  (
    {
      isError,
      isRequired,
      label,
      placeholder,
      value,
      onChange,
      iconColor,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={isError ? st.formInputError : st.formInput}>
        <FormField>
          {label && <FormLabel isRequired={isRequired}>{label}:</FormLabel>}
          <FormInput>
            <div className={st.inputContainer}>
              <div style={{ color: iconColor }} className={st.icon}>
                {children}
              </div>
              <div className={st.verticalSeparator}></div>
              <input
                ref={ref}
                className={st.input}
                placeholder={placeholder}
                type='text'
                value={value}
                onChange={onChange}
                onBlur={props?.onBlur}
              />
            </div>
          </FormInput>
        </FormField>
      </div>
    )
  },
)

InputWithIcon.propTypes = {
  isError: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  iconColor: PropTypes.string,
  onChange: PropTypes.func,
}

export default InputWithIcon
